import React from 'react';
import { Trans } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import BackdropDialog from 'common/components/BackdropDialog';

import { UserApi } from 'common/types';
import { useTranslation } from 'services/localization/useTranslation';

interface Props {
	open: boolean;
	value: UserApi;
	onDelete: (userId: string) => void;
	onClose: () => void;
}

const DeleteUserDialog = (props: Props) => {
	const { open, value, onDelete, onClose } = props;
	const { t } = useTranslation();

	return (
		<BackdropDialog
			isOpen={open}
			onClose={onClose}
			label={t('users.deleteUser', 'Delete user')}
			body={
				<Box>
					<Typography variant="body2">
						<Trans
							i18nKey="users.deleteUserText1"
							defaults="Remove <bold>{{email}}</bold> from your store?"
							values={{ email: value.email }}
							components={{
								bold: <b />,
							}}
						/>
					</Typography>
				</Box>
			}
			variant="danger"
			width="xs"
			confirm={{
				label: t('common:actions.delete'),
				callback: () => onDelete(value.id),
				closeAfterDone: true,
			}}
			cancel={{
				label: t('common:actions.cancel'),
			}}
		/>
	);
};

export default DeleteUserDialog;
